<template>
  <button
    class="bb-theme-switch"
    type="button"
    role="switch"
    :aria-checked="isDark ? 'true' : 'false'"
    :aria-label="$t('home.theme')"
    @click.stop="toggle"
  >
    <span class="bb-theme-thumb">
      <svg v-if="isDark" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path
          d="M6.66668 4.66732C6.66668 7.24465 8.75601 9.33398 11.3333 9.33398C12.6389 9.33398 13.8193 8.79778 14.6663 7.93365C14.6667 7.95598 14.6667 7.97832 14.6667 8.00065C14.6667 11.6825 11.6819 14.6673 8.00001 14.6673C4.31811 14.6673 1.33334 11.6825 1.33334 8.00065C1.33334 4.31875 4.31811 1.33398 8.00001 1.33398C8.02234 1.33398 8.04468 1.33398 8.06701 1.33431C7.20288 2.1813 6.66668 3.3617 6.66668 4.66732Z"
          fill="currentColor"
        />
      </svg>
      <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path
          d="M8 1.33301C8.36819 1.33301 8.66667 1.63149 8.66667 1.99967V3.33301C8.66667 3.7012 8.36819 3.99967 8 3.99967C7.63181 3.99967 7.33333 3.7012 7.33333 3.33301V1.99967C7.33333 1.63149 7.63181 1.33301 8 1.33301ZM8 12C8.36819 12 8.66667 12.2985 8.66667 12.6667V14C8.66667 14.3682 8.36819 14.6667 8 14.6667C7.63181 14.6667 7.33333 14.3682 7.33333 14V12.6667C7.33333 12.2985 7.63181 12 8 12ZM14.6667 8C14.6667 8.36819 14.3682 8.66667 14 8.66667H12.6667C12.2985 8.66667 12 8.36819 12 8C12 7.63181 12.2985 7.33333 12.6667 7.33333H14C14.3682 7.33333 14.6667 7.63181 14.6667 8ZM4 8C4 8.36819 3.70152 8.66667 3.33333 8.66667H2C1.63181 8.66667 1.33333 8.36819 1.33333 8C1.33333 7.63181 1.63181 7.33333 2 7.33333H3.33333C3.70152 7.33333 4 7.63181 4 8ZM11.8856 4.11438C12.146 3.85403 12.146 3.43192 11.8856 3.17157C11.6253 2.91122 11.2032 2.91122 10.9428 3.17157L10 4.11438C9.73967 4.37473 9.73967 4.79684 10 5.05719C10.2604 5.31754 10.6825 5.31754 10.9428 5.05719L11.8856 4.11438ZM6.05719 10C6.31754 9.73967 6.31754 9.31754 6.05719 9.05719C5.79684 8.79684 5.37473 8.79684 5.11438 9.05719L4.17157 10C3.91122 10.2604 3.91122 10.6825 4.17157 10.9428C4.43192 11.2032 4.85403 11.2032 5.11438 10.9428L6.05719 10ZM11.8856 11.8856C12.146 12.146 12.146 12.5681 11.8856 12.8284C11.6253 13.0888 11.2032 13.0888 10.9428 12.8284L10 11.8856C9.73967 11.6253 9.73967 11.2032 10 10.9428C10.2604 10.6825 10.6825 10.6825 10.9428 10.9428L11.8856 11.8856ZM6.05719 6.05719C6.31754 6.31754 6.31754 6.73967 6.05719 7C5.79684 7.26035 5.37473 7.26035 5.11438 7L4.17157 6.05719C3.91122 5.79684 3.91122 5.37473 4.17157 5.11438C4.43192 4.85403 4.85403 4.85403 5.11438 5.11438L6.05719 6.05719ZM8 5.33333C6.52724 5.33333 5.33333 6.52724 5.33333 8C5.33333 9.47276 6.52724 10.6667 8 10.6667C9.47276 10.6667 10.6667 9.47276 10.6667 8C10.6667 6.52724 9.47276 5.33333 8 5.33333Z"
          fill="currentColor"
        />
      </svg>
    </span>
  </button>
</template>
<script>
export default {
  name: "ThemeSwitch",
  computed: {
    isDark() {
      return this.$store.state.theme !== "light";
    }
  },
  methods: {
    toggle() {
      this.$store.commit("SET_THEME", this.isDark ? "light" : "dark");
    }
  }
};
</script>
<style scoped>
.bb-theme-switch {
  position: relative;
  width: 40px;
  height: 24px;
  padding: 2px;
  border: 0;
  border-radius: 999px;
  background: var(--bb-border);
  cursor: pointer;
  flex-shrink: 0;
}
.bb-theme-switch[aria-checked="true"] {
  background: var(--bb-brand);
}
.bb-theme-thumb {
  position: absolute;
  top: 50%;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--bb-always-white);
  color: var(--bb-always-black);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);
  transition: transform 0.2s ease;
  box-shadow: 0 0 4px rgba(4, 9, 25, 0.15);
}
.bb-theme-switch[aria-checked="true"] .bb-theme-thumb {
  transform: translate(16px, -50%);
}
</style>
